<template>
  <div class="nav-toolbar hidden-sm-and-down primary">
    <div class="container grid-list-md">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-items>
          <v-btn to="/" flat v-if="tieneRol">Inicio</v-btn>
          <v-btn to="/tasas" flat v-if="tieneRol">Tasas</v-btn>
          <v-btn to="/cuotas" flat v-if="gasOElectricidad">Cuotas</v-btn>
          <v-btn to="/salir" flat v-if="tieneRol">Salir</v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <span v-if="entorno"> <v-icon>settings</v-icon>{{ entorno }}</span>
      </v-toolbar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Navbar',
  props: {
    roles: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isGasElectricidad', 'entorno']),
    tieneRol() {
      return this.roles.length == 0 ? false : true;
    },
    gasOElectricidad() {
      //petroleo
      if (!this.isGasElectricidad) {
        return false;
      }
      //  gas y electricidad
      return true;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.nav-toolbar .container {
  padding: 0;
}
span {
  font-size: 1.5rem;
  i {
    margin-right: 10px;
  }
}
</style>
